import PopupFooter from ".";
import styled from "styled-components";
import bgHeaderTop from "../../../../../assets/images/Mini-Game/bg-header-popup-ranking.png";
import ComponentPiece from "./ComponentPiece";
import ComponentInviteUser from "./ComponentInviteUser";
import { useNewYear2025Theme } from "../../../../../helper/const";

const COMPONENT_PIECE_ACTIVE = 0;
export default function PopupRanking({ isOpen, setIsOpen = () => {} }) {
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  return (
    <ContainerRanking className="popup-minigame__2025 popup-mini-activity-his">
      <PopupFooter
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        className={"popup-ranking-mini"}
        srcImgHeader={bgHeaderTop}
      >
        {!IS_EVENT_NEW_YEAR_2025_THEME ? <ComponentPiece /> : <ComponentInviteUser />}
      </PopupFooter>
    </ContainerRanking>
  );
}

const ContainerRanking = styled.div`
  .rank-num__minigame {
    color: rgba(24, 34, 48, 1);
    font-weight: 600;
  }
`;
